import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from "@mui/material";
import Button from "./forms/button";
import React, { PropsWithChildren } from "react";
import { DealPageActionButtonInfo } from "../deals/dealsPageLayout/DealsPageHeader/DealsPageHeader";

type DKDialogProps = {
  open: DialogProps["open"];
  title: string;
  contentText?: string;
  actionButtons?: DealPageActionButtonInfo[];
};
export const DKDialog = (props: PropsWithChildren<DKDialogProps>) => {
  const { open, title, contentText, actionButtons } = props;
  return (
    <Dialog open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {contentText && contentText}
          <Box
            sx={{
              mt: 2,
            }}
          ></Box>
          {props.children}
        </DialogContentText>
      </DialogContent>
      {!!actionButtons?.length && (
        <DialogActions>
          {actionButtons.map((actionButton, index) => (
            <Button
              key={`action-button-${index}`}
              data-testid={actionButton.dataTestId}
              disabled={actionButton.disabled}
              type={actionButton.primary ? "primary" : "secondary"}
              size="medium"
              onClick={() => actionButton.onClick()}
            >
              {actionButton.label}
            </Button>
          ))}
        </DialogActions>
      )}
    </Dialog>
  );
};
